module.exports = __webpack_public_path__ + "static/media/fist-raised.6038aa67.svg";